<div id="openExtendsBookingsAmortization" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered {{sizeModal}}">
    <div class="modal-content" *ngIf="book != null">
      <div class="modal-header">
        <h5 class="modal-title mt-0" id="mySmallModalLabel">Amortizar reserva | <span class="bold">{{book.code}}</span>
        </h5>
        <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
            <span aria-hidden="true">×</span>
        </button> -->
      </div>
      <app-loading-modal></app-loading-modal>
      <ng-container *ngIf="book != null">
        <form validate [formGroup]="item" (ngSubmit)="preSave()" autocomplete="off">
          <div class="modal-body">
            <div class="card m-b-30 m-b-50">
              <div class="col-lg-12" *ngIf="validatealert">
                <ng-container *ngIf="moneybox != null">
                  <ng-container *ngIf="moneybox.status_closed == true || moneybox.is_before">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      Debe corregir el estado de la caja para realizar movimientos de dinero,
                      <!-- <a class="bold text-white text-underline" routerLink="/{{branchofficeSlug}}/caja/apertura">Clic para
                        ir a caja.</a> -->
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!check_moneybox">
                  <div class="alert alert-danger alert-dismissible fade show" role="alert">
                    Debe aperturar la caja para realizar movimientos de dinero,
                    <!-- <a class="bold text-white text-underline" routerLink="/{{branchofficeSlug}}/caja/apertura">Clic para
                      ir a caja.</a> -->
                  </div>
                </ng-container>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-9">
                      <label>Responsable reserva ( {{book.client_data.typeDocument}}:{{book.client_data.document}}
                        )<span class="required"></span> </label>
                      <input type="text" class="form-control" value="{{book.client_data.fullname}}" disabled>
                    </div>
                    <!-- <div class="form-group col-lg-3">
                      <label>Caja aperturada <span class="required"></span></label>
                      <select id="boxSelected" ng-model="boxSelected" ng-change="changeBox(boxSelected)" ng-required="true"
                        ng-disabled="true" ng-options="type.description for type in branchboxes"
                        class="form-control content__subhead__inputGrid__input">
                      </select>
                    </div> -->
                    <div class="form-group col-lg-3" *ngIf="boxselected != null">
                      <label>
                        Caja seleccionada
                        <span class="required"></span>
                      </label>
                      <input type="text" disabled value="{{boxselected.description}}" class="form-control">
                      <ng-container *ngIf="check_moneybox">
                        <ng-container *ngIf="moneybox.is_before">
                          <span class="badge badge-warning f-s-11" ng-if="moneybox.is_before">CONTINÚA EN FECHA ANTERIOR
                            :
                            {{moneybox.date_opening}}</span>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                  <div class="row" *ngIf="company.send_billing">
                    <ng-container *ngIf="company.billing_by_branch">
                      <div class="form-group col-lg-6">
                        <label>Seleccionar Oficina/local</label>
                        <select class="form-control" id="typeVoucherSelected" formControlName="branchoffice_id"
                          (change)="changeOffice()">
                          <option *ngFor="let item of branchoffices" [value]="item.id">{{ item.description }} - RUC: {{ item.ruc }}</option>
                        </select>
                      </div>
                      <div class="form-group col-lg-6">
                        <img width="140" height="60" src="tenants/{{branchOfficeSelected.url_image}}" alt="Preview">
                      </div>
                      <div class="form-group col-lg-6">
                        <ng-container *ngIf="branchOfficeSelected != null">
                          <label>Dirección Local</label>
                          <input type="text" class="form-control" value="{{ branchOfficeSelected.address}}" disabled>
                        </ng-container>                        
                      </div>
                    </ng-container>
                    <div class="form-group col-lg-6">
                      <label>Tipo Comprobante y serie <span class="required"></span>
                        <span *ngIf="this.typevoucher_factura.id == item.value.typevoucher_id"
                          class="badge badge-warning m-l-10">Debe seleccionar o especificar cliente con N° de RUC</span>
                      </label>
                      <div class="input-group">
                        <select class="form-control" id="typeVoucherSelected" formControlName="typevoucher_id"
                          (change)="changeTypeVoucher()">
                          <option *ngFor="let item of typevouchers" [value]="item.id">{{ item.description }} </option>
                        </select>
                        <span class="input-group-prepend">
                          <span class="input-group-text">SERIE</span>
                        </span>
                        <span class="input-group-prepend">
                          <select class="form-control" id="serieSelected" formControlName="serie">
                            <option *ngFor="let item of series" [value]="item.series">{{ item.series }} </option>
                          </select>
                        </span>
                      </div>
                    </div>
                    <div class="form-group col-lg-6">
                      <ng-container *ngIf="!OtherClient">
                        <div class="custom-control custom-checkbox m-t-25">
                          <input type="checkbox" class="custom-control-input" id="other_client"
                            [(ngModel)]="OtherClient" [ngModelOptions]="{standalone: true}"
                            (change)="changeOtherClient()">
                          <label class="custom-control-label p-t-3" for="other_client">¿Asignar otro cliente para
                            comprobante?</label>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="OtherClient">
                        <ng-container *ngIf="isClientSelected">
                          <label>Datos cliente comprobante ({{clientSelected.typeDocument}}:
                            {{clientSelected.document}})<span class="required"></span></label>
                          <div class="input-group">
                            <input type="text" class="form-control form-control-sm" disabled
                              value="{{clientSelected.fullname}}">
                            <div class="input-group-append bg-custom b-0 removeClient">
                              <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                                (click)="removeClient()">
                                <i class="fas fa-backspace w-100 f-s-12"></i>
                              </div>
                              <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                                data-toggle="modal" data-target="#openExtendsClient"
                                (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                                <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="!isClientSelected">
                          <label>Datos cliente comprobante <span class="required"></span>
                            <ng-container *ngIf="OtherClient">
                              <div class="float-right" style="margin-bottom: -5px;">
                                <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input"
                                    (change)="OtherClient=false; changeOtherClient()" id="check_client_responsible">
                                  <label class="custom-control-label p-t-3" for="check_client_responsible">¿Responsable
                                    reserva?</label>
                                </div>
                              </div>
                            </ng-container>
                          </label>
                          <div class="input-group input-group-grid">
                            <component-search-client [classSize]="'search-small'"
                              (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                            </component-search-client>
                            <div class="input-group-append b-0">
                              <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                                data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                                <i class="fas fa-user-plus w-100"></i>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                    <ng-container *ngIf="isRuc">
                      <ng-container *ngIf="isClientSelected">
                        <div class="col-lg-12 text-right">
                          <span *ngIf="clientSelected.typedocument_id != typedocument_ruc.id"
                            class="badge badge-danger f-s-13"><strong>CORREGIR URGENTE !!</strong> EL CLIENTE DEBE SER
                            CON TIPO DOCUMENTO RUC</span>
                        </div>
                      </ng-container>
                    </ng-container>

                    <ng-container *ngIf="isRuc">
                      <div class="form-group col-lg-12"
                        *ngIf="isClientSelected && clientSelected.typedocument_id == typedocument_ruc.id">
                        <label>Dirección Fiscal<span class="required"></span> </label>
                        <input type="text" class="form-control f-s-11" value="{{clientSelected.address}}" disabled>
                      </div>
                    </ng-container>
                  </div>
                  <div class="row" *ngIf="company.send_billing && item.value.typevoucher_id != typevoucher_recibo.id">
                    <div class="col-lg-12 m-t-10 m-b-20">
                      <p class="form__group__title"> <i class="fa fa-money-bill m-r-3"></i>
                        Asociar Servicio comprobante<span class="required"></span>
                        <ng-container>
                          <div style="display: inline-block;" class="m-l-25">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input" id="detail_service"
                                [(ngModel)]="detailService" [ngModelOptions]="{standalone: true}"
                                (change)="changeDetailService()">
                              <label class="custom-control-label f-s-13" for="detail_service">¿Crear detalle
                                servicio?</label>
                            </div>
                          </div>
                        </ng-container>
                      </p>
                      <ng-container *ngIf="detailService">
                        <textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="service_data.text_detail_service"
                          (ngModelChange)="convertToUppercase()" id="text_detail_service"
                          class="form-control no-resize text-uppercase" rows="2"></textarea>
                      </ng-container>
                      <ng-container *ngIf="!detailService">
                        <ng-container *ngIf="isServiceSelected">
                          <div class="input-group">
                            <textarea class="form-control no-resize" rows="2"
                              disabled>{{serviceSelected.description}}</textarea>
                            <!-- <input type="text" class="form-control form-control-sm" disabled value=""> -->
                            <div class="input-group-append bg-custom b-0 removeClient">
                              <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                                (click)="removeService()">
                                <i class="fas fa-backspace w-100 f-s-12"></i>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="!isServiceSelected">
                          <component-search-product [typeProduct]="2" [controlStock]="false"
                            placeholderText="Buscar servicio" (selectedProductEvent)="selectedServiceSearch($event)">
                          </component-search-product>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-lg-3">
                      <label>Método de pago <span class="required"></span></label>
                      <select class="form-control" id="paymentSelected" formControlName="paymentmethod_id"
                        (change)="changePaymentMethod()" required>
                        <option *ngFor="let item of paymentmethods" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                    <ng-container *ngIf="paymentMethodSelected.associate_bank">
                      <div class="form-group col-lg-6">
                        <label>Cuenta destino
                          <span class="f-s-9" *ngIf="accountbanks.length == 0">( 0 registros )</span>
                          <!-- <button type="button" ng-click="addAccountBank(true)" ng-if="bankaccounts_exists == true"
                            class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                          </button> -->
                        </label>
                        <ng-container *ngIf="accountbanks.length == 0">
                          <a type="button" class="btn btn-outline-info text-white"
                            routerLink="/{{branchofficeSlug}}/finanzas/cuentas_bancarias/lista">
                            <i class="fas fa-arrow-right m-r-5"></i>Agregar Cuenta
                          </a>
                        </ng-container>
                        <ng-container *ngIf="accountbanks.length > 0">
                          <select class="form-control" id="bankAccountSelected"
                            (change)="changeBankAccount($event.target)">
                            <option *ngIf="!isEdit" value="null">Seleccionar cuenta</option>
                            <option *ngFor="let item of accountbanks" [value]="item.id">{{ item.concat_description}}
                            </option>
                          </select>
                        </ng-container>
                      </div>
                      <div class="form-group col-lg-3">
                        <label>N° operación</label>
                        <input type="text" class="form-control" formControlName="reference_operation">
                      </div>
                    </ng-container>
                    <div class="form-group col-lg-3">
                      <label class="text-right">TOTAL A PAGAR</label>
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold f-s-14 text-primary">{{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" disabled class="form-control text-right bold f-s-14 text-primary"
                          value="{{book.total - book.total_paid}}">
                      </div>
                    </div>
                    <div class="form-group col-lg-3">
                      <label class="text-right">MONTO A PAGAR <span class="required"></span></label>
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text">{{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control text-right bold f-s-14" id="amount_paid"
                          formControlName="amount" numeric decimals="2" onclick="click_input(this)"
                          (keyup)="calculate_difference()">
                      </div>
                    </div>
                    <div class="form-group col-lg-3">
                      <label class="text-right">SALDO RESTANTE</label>
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold f-s-14 text-danger">{{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" disabled class="form-control text-right bold f-s-14 text-danger"
                          value="{{amount_paid}}">
                      </div>
                      <!-- <p class="text-danger bold m-b-0 f-s-16 text-center">
                        {{toolsService.momeySol()}} {{amount_paid}}
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-t-15">
                <div class="form-group col-lg-6 m-t-15">
                  <label>Adjuntar constancia</label>
                  <input id="fileUrlImage" type="file" accept="image/png, image/jpeg, image/jpg"
                    (change)="onFileSelected($event)">
                </div>
                <div class="form-group col-lg-6">
                  <label>Observación</label>
                  <textarea rows="1" class="form-control no-resize" formControlName="observation"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer nowrap">
            <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
              (click)="close()">Cancelar</button>
            <button type="submit" class="btn btn-primary"><i class="fas fa-check m-r-3"></i>AMORTIZAR RESERVA</button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>
<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
